import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, VoiceAIOutreach } from "@/types";

export function useCancelVoiceAIOutreach() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({
      candidacyId,
      voiceAIOutreachId,
    }: {
      candidacyId: string;
      voiceAIOutreachId: string;
    }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/voice-ai-outreaches/${voiceAIOutreachId}/cancel`;
      const res = await guacHttpClient.post<
        VoiceAIOutreach,
        HttpResponse<VoiceAIOutreach>
      >(path);

      return res.data;
    },
    onSuccess: (_data, { candidacyId }) => {
      void queryClient.invalidateQueries({
        queryKey: [
          "voice-ai-outreaches",
          currentCompanyId,
          currentJobId,
          candidacyId,
        ],
      });
    },
  });

  return mutation;
}
